import type { CSSProperties } from "react"

import { tv, type VariantProps } from "@/lib/utils/tv"

const track = tv({ base: "bg-surface-newgray h-2 overflow-hidden rounded-full" })

const fill = tv({
  base: "h-full rounded-full ease-productive duration-moderate transition-all",
  variants: { tone: { brand: "bg-brand", success: "bg-surface-success", gold: "bg-vip-gold" } },
  defaultVariants: { tone: "brand" },
})

interface ProgressProps extends VariantProps<typeof fill> {
  value: number
  className?: string
}

export const Progress = ({ value, tone, className }: ProgressProps) => {
  const pct = Math.max(0, Math.min(1, value))
  return (
    <div role="progressbar" aria-valuenow={Math.round(pct * 100)} aria-valuemin={0} aria-valuemax={100} className={track({ className })}>
      <div className={fill({ tone })} style={{ width: `${pct * 100}%` } as CSSProperties} />
    </div>
  )
}
